import React, { useEffect, useRef } from 'react'
import { inViewport, track } from '~/utils'

const ViewportTracking = ({ children, event, payload }) => {
  const viewportRef = useRef()

  useEffect(() => {
    let hasTrackedView = false

    const trackViewed = () => {
      const ref = viewportRef.current
      const isInViewport = inViewport(ref)

      if (isInViewport && !hasTrackedView) {
        hasTrackedView = true
        track(event, payload)
      }
    }

    window.addEventListener('scroll', trackViewed)

    return () => {
      window.removeEventListener('scroll', trackViewed)
    }
  }, [event, payload])

  return <div ref={viewportRef}>{children}</div>
}

export default ViewportTracking
